import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Mail, MapPin, Phone } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-primary text-primary-foreground">
      {/* Footer Links */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="font-heading text-2xl font-bold">
              Dockside Design
            </Link>
            <p className="mt-4 text-primary-foreground/70 text-sm">
              Modern websites for local businesses — built fast and done professionally.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {['Home', 'Services', 'Portfolio', 'Pricing', 'Blog', 'About', 'Contact'].map((item) => (
                <li key={item}>
                  <Link
                    to={item === 'Home' ? '/' : `/${item.toLowerCase()}`}
                    className="text-primary-foreground/70 hover:text-accent transition-colors text-sm"
                  >
                    {item}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/seo-check"
                  className="text-accent hover:text-accent/80 transition-colors text-sm font-semibold"
                >
                  Free SEO Check
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/70">
              <li>Business Websites</li>
              <li>Restaurant Sites</li>
              <li>Service Company Sites</li>
              <li>Website Redesigns</li>
              <li>Hosting & Support</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-sm text-primary-foreground/70">
                <Mail size={16} className="text-accent" />
                <span>welcome@docksidedesign.co.uk</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-primary-foreground/70">
                <Phone size={16} className="text-accent" />
                <span>+44 779937806</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-primary-foreground/70">
                <MapPin size={16} className="text-accent" />
                <span>United Kingdom</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-primary-foreground/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-primary-foreground/60">
            © {currentYear} Dockside Design.
          </p>
          <div className="flex gap-6 text-sm text-primary-foreground/60 flex-wrap justify-center">
            <Link to="/privacy" className="hover:text-accent transition-colors">
              Privacy Policy
            </Link>
            <Link to="/business-outreach-privacy" className="hover:text-accent transition-colors">
              Business Outreach
            </Link>
            <Link to="/terms" className="hover:text-accent transition-colors">
              Terms of Service
            </Link>
            <Link to="/sub-processors" className="hover:text-accent transition-colors">
              Sub-processors
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
